module.exports = __webpack_public_path__ + "img/CM-BS-24-GMC-Lifestyle.d8d1fdeb.jpg";